export default __webpack_public_path__ + "d7dba6f5bfff32f7fb6dcb383c15551c.svg";